import { createContext } from 'react';

const AnalyticsContext = createContext();

export default AnalyticsContext;
